import { apiPost } from '../api'

export const sign_in = data => {
  return apiPost({
    endpoint: 'user/user_sign_in',
    data: data
  })
}
